import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const modalBox = css`
  max-height: calc(100vh - ${theme.spacing(8)});
  max-width: calc(100vw - 48px);
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.medium};
  position: relative;
  padding: ${theme.spacing(3, 0)};

  & > ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  & > ::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.neutral20};
    border-radius: ${theme.borderRadius.small};
  }
`;

export const modalBoxScroll = css`
  overflow-y: auto;
`;

export const modalBoxFlex = css`
  display: grid;

  & > * {
    min-width: 0;
    min-height: 0;
  }

  &:has(.wv-modal-flex-content):not(:has(> .wv-modal-header, > .wv-modal-label, > .wv-modal-footer)) {
    grid-template-rows: [body-start] minmax(0, 1fr) [body-end];
  }

  &:has(.wv-modal-flex-content + .wv-modal-footer):not(:has(> .wv-modal-header, > .wv-modal-label)) {
    grid-template-rows: [body-start] minmax(0, 1fr) [body-end] ${theme.spacing(3)} [footer-start] auto [footer-end];
  }

  &:has(.wv-modal-header + .wv-modal-flex-content):not(:has(> .wv-modal-label, > .wv-modal-footer)) {
    grid-template-rows: [header-start] auto [header-end] ${theme.spacing(1)} [body-start] minmax(0, 1fr) [body-end];
  }

  &:has(.wv-modal-header + .wv-modal-label + .wv-modal-flex-content):not(:has(> .wv-modal-footer)) {
    grid-template-rows:
      [header-start] auto [header-end] 0 [label-start] auto [label-end] ${theme.spacing(1)} [body-start] minmax(0, 1fr)
      [body-end];
  }

  &:has(.wv-modal-header + .wv-modal-flex-content + .wv-modal-footer):not(:has(> .wv-modal-label)) {
    grid-template-rows: [header-start] auto [header-end] ${theme.spacing(1)} [body-start] minmax(0, 1fr) [body-end] ${theme.spacing(
        3
      )} [footer-start] auto [footer-end];
  }

  &:has(.wv-modal-header + .wv-modal-label + .wv-modal-flex-content + .wv-modal-footer) {
    grid-template-rows:
      [header-start] auto [header-end] 0 [label-start] auto [label-end] ${theme.spacing(1)} [body-start] minmax(0, 1fr)
      [body-end] ${theme.spacing(3)} [footer-start] auto [footer-end];
  }
`;
